<script lang="ts">
	let visible = $state(false);

	$effect(() => {
		const onScroll = () => {
			visible = window.scrollY > 500;
		};
		onScroll();
		window.addEventListener("scroll", onScroll, { passive: true });
		return () => {
			window.removeEventListener("scroll", onScroll);
		};
	});

	function scrollToTop() {
		window.scrollTo({ top: 0, behavior: "smooth" });
	}
</script>

<button
	type="button"
	aria-label="Zpět nahoru"
	onclick={scrollToTop}
	class={[
		"fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-fstonyx text-fstivory shadow-lg transition-all duration-300 hover:bg-fstgrey-900 focus-visible:ring-fstgreen focus-visible:outline-none focus-visible:ring-2",
		visible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0",
	]}
>
	<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
		<path
			d="M12 19V5M12 5L5 12M12 5L19 12"
			stroke="currentColor"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</button>
